import React from "react";
import FooterCommon from "@clarion/feature/dist/SiteComponents/containers/Footer/index";
import FooterPrimaryCommon from "@clarion/feature/dist/SiteComponents/components/FooterPrimary/index";
import FooterSecondaryCommon from "@clarion/feature/dist/SiteComponents/components/FooterSecondary/index";
import "./index.css";

const Footer = (props) => {
    const templateIds = {
        FooterLink: "{56FC1BC6-F5DF-41A9-9ADC-F267C3670B10}",
        GroupSitesFooter: "{3145B8EB-997A-41BF-A879-7FB17B54EFAB}",
        PolicyLinkFooter: "{99FBA417-FEB5-4A7A-AC4B-3A6C83796C70}",
        SocialMediaFooter: "{269D93FA-A7F7-4041-8681-5F1057AB6A42}"
    };

    return (
        <FooterCommon>
            <FooterPrimaryCommon {...props} templateIds={templateIds} />
            <FooterSecondaryCommon {...props} templateIds={templateIds} />
        </FooterCommon>
    );
};

export default Footer;
